import { Controller } from "@hotwired/stimulus"

/**
 * Connects to data-controller="contacts--timeline-comment"
 *
 * The "Show full comment" toggle on a quote-comment card of the Hotwire Site
 * Timeline (CONEK-7139) — parity with the React CommentEventBody toggle.
 *
 * Collapsed, the card shows the stored excerpts. The first expand points the
 * hidden Turbo Frame at the audited-body endpoint (`src` value) so the full
 * bodies load lazily, once — the audited snapshot is immutable, so it is never
 * refetched. The excerpt is hidden only while expanded AND the full bodies
 * actually loaded (the frame holds a `[data-comment-full]` node): while the
 * fetch is in flight, or after it failed, the excerpt stays visible above the
 * loading / error text, exactly like React.
 */
export default class extends Controller {
  static targets = ["excerpt", "panel", "frame", "showLabel", "hideLabel"]
  static values = { src: String, expanded: Boolean }

  toggle(event) {
    const button = event.currentTarget
    this.expandedValue = !this.expandedValue

    if (this.expandedValue && !this.frameTarget.getAttribute("src")) {
      this.frameTarget.setAttribute("src", this.srcValue)
    }

    this.panelTarget.hidden = !this.expandedValue
    this.showLabelTarget.hidden = this.expandedValue
    this.hideLabelTarget.hidden = !this.expandedValue
    button?.setAttribute("aria-expanded", String(this.expandedValue))
    this.sync()
  }

  sync() {
    const loaded =
      this.frameTarget.querySelector("[data-comment-full]") !== null
    this.excerptTarget.hidden = this.expandedValue && loaded
  }
}
